import React from "react";
import { useTranslation } from "react-i18next";
import LanguageSettingsSkeleton from "./Skeleton";
import LanguageSettingsForm from "./Form";
import { useGetLanguageSettings } from "../../../../hooks/queries/languageSettings";

export default function LanguageSettings() {
  const { t } = useTranslation();
  const { data, isError } = useGetLanguageSettings();

  if (isError) return <p>{t("settings.languages.error")}</p>;
  if (data) return <LanguageSettingsForm initialLanguageSettings={data} />;
  return <LanguageSettingsSkeleton />;
} 